import React from "react";
import CountUp from "react-countup";

import "./ProjectCard.css";

const ProjectDetails = ({ cardInfo }) => {
  const openInNewTab = (url) => {
    var win = window.open(url, "_blank");
    win.focus();
  };
  return (
    <>
      <div className="proj-card-footer">
        {cardInfo.footer.map((info, index) => {
          return (
        null
          );
        })}
  
      </div>
    </>
  );
};

export default ProjectDetails;
